<script setup>
import VModal from "@/Shared/VModal.vue";
import VButton from "@/Shared/Buttons/VButton.vue";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit.vue";

import VInputWithLabel from "@/Shared/Form/VInputWithLabel.vue";
import VSelectDefaultWithLabel from "@/Shared/Form/VSelectDefaultWithLabel.vue";

import { ref } from "vue";
import { router, useForm } from "@inertiajs/vue3";

const props = defineProps({
    templateOptions: Array,
    urlDownload: String,
});

const refModal = ref(null);
const form = useForm({
    template_id: 1,
    start: "",
    end: "",
});

const emits = defineEmits(["onCancel"]);

const cancel = () => {
    emits("onCancel");
};

const save = () => {
    const param = new URLSearchParams({
        template_id: form.template_id,
        start: form.start,
        end: form.end,
    }).toString();
    const url = props.urlDownload + "?" + param;

    window.open(url, "_blank");
};
</script>

<template>
    <VModal title="Download" ref="refModal" size="modal-md" @onClose="cancel">
        <template v-slot:body>
            <div class="row m-2">
                <div class="col-12 mb-3">
                    <VSelectDefaultWithLabel
                        elId="template_id"
                        label="Template"
                        v-model:value="form.template_id"
                        :error="form.errors?.template_id"
                        :options="templateOptions"
                    />
                </div>
                <div class="col-12 mb-3">
                    <VInputWithLabel
                        elId="start"
                        label="Start"
                        v-model:value="form.start"
                        type="date"
                        :error="form.errors?.start"
                    />
                </div>
                <div class="col-12 mb-3">
                    <VInputWithLabel
                        elId="end"
                        label="End"
                        v-model:value="form.end"
                        type="date"
                        :error="form.errors?.end"
                    />
                </div>
            </div>
        </template>

        <template v-slot:footer>
            <VButton @onClick="refModal.closeModal()"> Cancel </VButton>
            <VButtonSubmit type="button" @onCLickSubmit="save">
                Download
            </VButtonSubmit>
        </template>
    </VModal>
</template>
